exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ps-shimmer--animate{animation:shimmer 4s infinite;background-size:1000px 100% !important}@keyframes fullView{100%{width:100%}}@keyframes shimmer{0%{background-position:-1000px 0}100%{background-position:1000px 0}}\n", ""]);

// exports
